import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from "../../../../middlewares/api/actions";
import {
    TRANSCODING_GET_ID,
    TRANSCODING_SETTINGS_DATASET_COLUMN,
    TRANSCODING_SETTINGS_DATA_CLEAR_CHANGES,
    TRANSCODING_SETTINGS_DATA_CODE_MATCH,
    TRANSCODING_SETTINGS_DATA_IMPORT_DATA_FILE,
    TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_HIDE,
    TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_SHOW,
    TRANSCODING_SETTINGS_DATA_TABLE_DELETE_DSD_VALUE_ITEM,
    TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST,
    TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET,
    TRANSCODING_SETTINGS_HIDE,
    TRANSCODING_SETTINGS_HIDE_TIME_DIMENSION,
    TRANSCODING_SETTINGS_MODE,
    TRANSCODING_SIMPLE_VALUE_SET,
    TRANSCODING_SETTINGS_UPDATE_CODELIST,
    TIME_TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET,
    TRANSCODING_SETTINGS_HIDE_DIMENSION,
    TRANSCODING_CHANGE_LANGUAGE,
    TRANSCODING_LIST_CODELIST_CODES_ITEMS_PAGE_READ
} from "./actions";
import _ from 'lodash';
import { cartesianProduct, generateDataToGetTranscoding } from "./settings/utils";
import { checkImportedCSV } from "../utils";
import {
    CODELIST_ORDER_ANNOTATION_KEY,
    getItemSchemeFromSdmxJsonFactory,
    getSdmxStructuresFromSdmxJson,
    SDMX_JSON_CODELIST_ITEMS_KEY
} from '../../../../utils/sdmxJson';
import {getCurrentNodeConfig} from '../../../../middlewares/current-node-config/middleware';


const transcodingSettingsReducer = (state = {
    showTranscodingSettings: false,
    mode: null,
    showTranscodingSettingsTimeDimension: false,
    showTranscodingSettingsWithoutTimeDimension: false,
    data: null,
    columnDataset: null,
    columnCodelist: null,
    slidersValue: [],
    dataTable: null,
    dataFile: null,
    DSDcomponent: null,
    csvData: null,
    showCodeMatch: false,
    modalLanguage: 'en',
    rulesToTranscoding: null,
    rows:null
}, action) => {
    switch (action.type) {
        case TRANSCODING_SIMPLE_VALUE_SET:
            return {
                ...state,
                data: { ...state.data, constantValue: action.value },
            }
        case TRANSCODING_SETTINGS_MODE:
            return {
                ...state,
                mode: action.mode
            }
        case TRANSCODING_SETTINGS_HIDE:
            return {
                ...state,
                showTranscodingSettings: false,
                data: null,
                columnDataset: null,
                columnCodelist: null,
                showCodeMatch: false,
                mode: null,
                transcodingEntityId: null,
                dataTable: null,
                slidersValue: [],
            }
        case TRANSCODING_SETTINGS_HIDE_TIME_DIMENSION:
            return {
                ...state,
                data: null,
                showTranscodingSettingsTimeDimension: false,
                columnDataset: null,
                columnCodelist: null,
                showCodeMatch: false,
                mode: null,
                transcodingEntityId: null,
                dataTable: null,
                slidersValue: [],
            }
        case TRANSCODING_SETTINGS_HIDE_DIMENSION:
            return {
                ...state,
                data: null,
                showTranscodingSettingsWithoutTimeDimension: false,
                columnDataset: null,
                columnCodelist: null,
                showCodeMatch: false,
                mode: null,
                transcodingEntityId: null,
                dataTable: null,
                slidersValue: [],
            }
        case TRANSCODING_SETTINGS_DATASET_COLUMN:
            return {
                ...state,
                showTranscodingSettings: true,
                data: action.data,
            }        
        case TRANSCODING_SETTINGS_DATA_CLEAR_CHANGES:
            const oldData = _.cloneDeep(state.dataTable)
            const newData = _.map(oldData, (e) => _.assign({ ...e, Component: null }))
            return {
                ...state,
                dataTable: newData
            }
        case TRANSCODING_SETTINGS_DATA_IMPORT_DATA_FILE:
            const dataTableToCheck = _.cloneDeep(state.dataTable);
            const componentName = _.cloneDeep(state.data.dsdColumnName);
            const newDataTable = checkImportedCSV(dataTableToCheck, action.csvData, state.columnCodelist, componentName, action.t);
            return {
                ...state,
                csvData: action.csvData,
                dataTable: newDataTable
            }
        case TRANSCODING_SETTINGS_DATA_TABLE_DELETE_DSD_VALUE_ITEM:
            const setValue = _.cloneDeep(state.dataTable)
            _.assign(setValue[action.index], { ...setValue[action.index], Component: null })
            return {
                ...state,
                dataTable: setValue
            }
        case TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_SHOW:
            return {
                ...state,
                DSDcomponent: action.index
            }
        case TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_HIDE:
            return {
                ...state,
                DSDcomponent: null
            }
        case TRANSCODING_SETTINGS_UPDATE_CODELIST:
            const dataTableClone = _.cloneDeep(state.dataTable);
            const component = {};
            component.Code = action.codelist.id;
            component.NameEn = action.codelist.__originalRow.name.en || "";
            component.NameIt = action.codelist.__originalRow.name.it || "";
            dataTableClone[state.DSDcomponent].Component = component;
            return {
                ...state,
                dataTable: dataTableClone
            }
        case TRANSCODING_CHANGE_LANGUAGE:
            return {
                ...state,
                modalLanguage: action.language
            }
        case REQUEST_START:
            switch (action.label) {
                case TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET:
                    return {
                        ...state,
                        columnDataset: null
                    }
                case TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST:
                    return {
                        ...state,
                        columnCodelist: null
                    }
                case TRANSCODING_GET_ID:
                    return {
                        ...state,
                        transcodingGet: null
                    }
                default:
                    return { ...state }
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case TRANSCODING_SETTINGS_DATA_CODE_MATCH:
                    return {
                        ...state,
                        dataTable: action.response
                    }
                case TRANSCODING_LIST_CODELIST_CODES_ITEMS_PAGE_READ:
                    const items = getItemSchemeFromSdmxJsonFactory(
                        SDMX_JSON_CODELIST_ITEMS_KEY,
                        getCurrentNodeConfig(action).annotations,
                        CODELIST_ORDER_ANNOTATION_KEY
                    )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || [];

                    const isInvisibleItem = item => {
                        return item.annotations && (
                            item.annotations.find(annot =>
                                annot.id === "INVISIBLE" &&
                                annot.title === "INVISIBLE" &&
                                annot.type === "INVISIBLE"
                            ) !== undefined
                        );
                    };

                    const codelistCodesItemsPage = items
                        .filter(item => !isInvisibleItem(item));

                    return {
                        ...state,
                        componentCodelistCodesItemsPage: codelistCodesItemsPage,
                        componentCodelistCodesItemsCount: Number(action.header["x-total-count"]),
                    };
                case TRANSCODING_GET_ID:
                    return {
                        ...state,
                        transcodingGet: action.response
                    }
                case TRANSCODING_SETTINGS_DATASET_COLUMN: {

                    const isTimeDimension = action.response.isTimeDimensionMapping
                    let isTranscodingWithoutTimeDimension = !action.data.dsdType.includes('TimeDimension');
                    return {
                        ...state,
                        showTranscodingSettings: !action.data.dataset_column || action.data.dataset_column.length === 0,
                        showTranscodingSettingsTimeDimension: isTimeDimension && action.data.dataset_column.length > 0,
                        showTranscodingSettingsWithoutTimeDimension: isTranscodingWithoutTimeDimension && action.data.dataset_column.length > 0,
                        data: {
                            ...action.data,
                            transcoding: !action.response.componentMappingEntityId ? null : action.response
                        },
                        timeTranscodings: action.response.timeTranscodings && action.response.timeTranscodings.length > 0 ? action.response.timeTranscodings : null,
                        transcodingEntityId: action.response.transcodingEntityId

                    }
                }
                case TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET:
                    const columns = _.map(action.response, 'column')
                    const cartesianItems = cartesianProduct(_.map(action.response, 'values'))
                    const cloneDatasetCodelist = _.cloneDeep(state.columnCodelist)
                    const cloneData = _.cloneDeep(state.data)
                    const table = []
                    if (!!cloneData && !cloneData.transcoding) {
                        for (let i = 0; i < cartesianItems.length; i++) {
                            table.push(_.assign({}, { key: i, ..._.zipObject(columns, cartesianItems[i]), Component: null }))
                        }
                    }
                    if (!!cloneData && !!cloneData.transcoding) {
                        const tableCartesian = []
                        for (let i = 0; i < cartesianItems.length; i++) {
                            tableCartesian.push(_.assign({}, { key: i, ..._.zipObject(columns, cartesianItems[i]), Component: null }))
                        }
                        let dataTranscoding = generateDataToGetTranscoding(cloneData.transcoding, cloneData, cloneDatasetCodelist, tableCartesian)
                        _.filter(dataTranscoding, (e) => table.push(e))
                    }
                    return {
                        ...state,
                        columnDataset: action.response,
                        dataTable: table
                    }
                case TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST:
                    return {
                        ...state,
                        columnCodelist: action.response
                    }
                case TIME_TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET:
                    return {
                        ...state,
                        columnData: action.response,
                        slidersValue: (action.columnName || []).map(colName => {
                            const colValues = action.response.find(item => item.column === colName);
                            return {
                                    name: colName,
                                    value: colValues ? colValues.values.sort((a, b) => b.length - a.length)[0] : "",
                                }
                            }
                        )
                    }
                default:
                    return { ...state }
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET:
                    return {
                        ...state,
                        columnDataset: null
                    }
                case TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST:
                    return {
                        ...state,
                        columnCodelist: null
                    }
                case TRANSCODING_GET_ID:
                    return {
                        ...state,
                        transcodingGet: null
                    }
                default:
                    return { ...state }
            }
        default:
            return {
                ...state
            }
    }
}

export default transcodingSettingsReducer;
